import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { httpOptions } from './base-resource.service';
import { Injectable } from '@angular/core';

@Injectable()
export class FunctionService {
  constructor(protected readonly http: HttpClient) {}

  getCalenderSetupURL() {
    return this.http.get<{ url: string }>(
      `${environment.resourceService}/scheduled-meetings/fn/authenticate-calender`,
      {
        ...httpOptions,
      },
    );
  }
}
